<button
  mat-icon-button
  class="text-white/60 hover:text-white flex justify-center items-center"
  (click)="onClickBack()"
>
  @if (selectedTool()) {
    <mat-icon>arrow_back</mat-icon>
  } @else {
    <mat-icon>exit_to_app</mat-icon>
  }
</button>
@if (!selectedTool()) {
  <div
    class="relative justify-center items-center px-2 py-1 text-sm lg:text-base text-white hidden sm:flex"
  >
    {{ title() }}
  </div>
}
